import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import Select from "react-select"; // Importa o react-select
import ApiService from "../util/ApiService";
import UsersSearch from "../dashboard/calender/UsersSearch";

const DepartmentUserModal = ({ show, onHide, userInit = false }) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedDepartments, setSelectedDepartments] = useState([]); // Agora armazena múltiplos departamentos
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);

    useEffect(() => {
        if (show) {
            const loadData = async () => {
                await fetchDepartments(); // aguarda carregar os departamentos
                if (userInit) {
                    setSelectedUser(userInit);
                } else {
                    setSelectedUser(null);
                }
                setSelectedDepartments([]); // Limpa antes de carregar
            };
            loadData();
        }
    }, [show]);


    useEffect(() => {
        if (selectedUser) {


            fetchUserDepartmentsSelected();

        }
    }, [selectedUser]);


    const fetchUserDepartmentsSelected = async (userInit = false) => {
        try {
            setLoadingSearch(true);
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/users-list-selected`,
                { user_id: selectedUser?.value || selectedUser?.id},
                true
            );

            if (response.code === 200) {

                const {data} = ApiService.handleApiResponse(response);


                // Transforma os departamentos retornados para o formato esperado pelo Select
                const selectedDepartmentsFormatted = data.map((dept) => ({
                    value: dept.departments_id,
                    label: departments.find((d) => d.id === dept.departments_id)?.name || `Departamento ${dept.departments_id}`
                }));

                setSelectedDepartments(selectedDepartmentsFormatted); // Define os departamentos selecionados
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSearch(false);
        }
    };



    const fetchDepartments = async () => {
        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/list-department`,
                { all: true, status: 'S'},
                true
            );

            if (response.code === 200) {

                const {data} = ApiService.handleApiResponse(response);

                setDepartments(
                    Array.isArray(data) ? data : []
                );
            } else {
                Swal.fire("Erro", "Erro ao carregar os departamentos.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setDepartments([]);
        }
    };

    const handleSave = async () => {
        if (!selectedUser) {
            Swal.fire("Atenção", "Selecione um usuário antes de salvar.", "warning");
            return;
        }


        setLoading(true);
        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/register-user-array`,
                {
                    department_id: selectedDepartments.map((dept) => dept.value), // Envia um array de IDs
                    user_id: selectedUser?.value || selectedUser?.id
                },
                true
            );

            if (response.code === 200) {

                const { message, data }  = ApiService.handleApiResponse(response);

                let swalMessage = "";

                if (data.added?.length > 0) {
                    swalMessage += `Vinculado com sucesso em <b>${data.added?.length}</b> novo(s) departamento(s).<br>`;
                }
                if (data.ignored?.length > 0) {
                    swalMessage += `Mantido o(s) <b>${data.ignored.length}</b> departamentos já vínculados.`;
                }

                if(!swalMessage){
                    swalMessage =  data.message;
                }
                    // Exibir no SweetAlert2
                Swal.fire("Informação", swalMessage, "info").then(() => {
                    onHide(true);
                });
            } else {
                Swal.fire("Erro", "Erro ao registrar o usuário nos departamentos.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Vincular Plantonista Departamento</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="p-3">

                    <div className="mb-3">
                        <UsersSearch initialUser={userInit} onUserSelect={(user) => setSelectedUser(user)}/>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Departamentos:</label>
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <Select
                                    isMulti
                                    options={departments.map((dept) => ({
                                        value: dept.id,
                                        label: dept.name,
                                    }))}
                                    value={selectedDepartments}
                                    onChange={setSelectedDepartments}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Selecionar Departamento..."
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({...base, zIndex: 9999}),
                                        menu: base => ({...base, zIndex: 9999}),
                                    }}
                                />
                            </div>
                            {loadingSearch && (
                                <span
                                    className="spinner-border spinner-border-sm ms-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            )}
                        </div>
                    </div>


                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-dark" onClick={() => onHide()} disabled={loading}>
                        <i className="fa fa-close"></i> Cancelar
                    </button>
                    <button type="button" className="btn btn-info ms-2" onClick={() => handleSave()} disabled={loading}>

                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-plus"></i> Salvar
                            </>
                        )}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DepartmentUserModal;
